import React from 'react';
import { classNames } from './classNames';

export interface ColorSwatchProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  color: string;
  label: string;
  selected?: boolean;
  size?: number;
}

const ColorSwatch = React.forwardRef<HTMLButtonElement, ColorSwatchProps>(({
  color,
  label,
  selected = false,
  size = 30,
  type = 'button',
  className,
  style,
  disabled,
  ...props
}, ref) => (
  <button
    ref={ref}
    type={type}
    aria-label={label}
    aria-pressed={selected}
    title={label}
    disabled={disabled}
    className={classNames('color-swatch', className)}
    style={{
      backgroundColor: color,
      width: `${size}px`,
      height: `${size}px`,
      borderRadius: '50%',
      cursor: disabled ? 'not-allowed' : 'pointer',
      border: selected ? '3px solid #007bff' : '1px solid #dee2e6',
      boxShadow: selected ? '0 0 5px rgba(0, 123, 255, 0.5)' : 'none',
      transform: selected ? 'scale(1.1)' : 'scale(1)',
      transition: 'all 0.1s ease-in-out',
      padding: 0,
      ...style,
    }}
    {...props}
  />
));

ColorSwatch.displayName = 'ColorSwatch';

export default ColorSwatch;
